"use client";

import React from "react";
import { CircleCheck, PhoneCall, CalendarCheck } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Quickreferencestrip() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const specs = [{
    title: "We Collect",
    description: "We only gather essential data required to provide our premium services, ensuring your digital footprint remains minimal and secure."
  }, {
    title: "Never Sell",
    description: "Your personal information is yours alone. We maintain a strict policy against selling or sharing your data with third-party brokers."
  }, {
    title: "We Protect",
    description: "Utilizing military-grade encryption and advanced security protocols to safeguard your sensitive information from unauthorized access."
  }];
  return <section data-section-id="260736" id="quickreferencestrip" className="py-16 md:py-24 bg-background text-foreground overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Image Column */}
          <div className={`relative rounded-lg overflow-hidden shadow-md transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <AspectRatio ratio={4 / 3}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/data_privacy_security_shield.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/data_privacy_security_shield.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/data_privacy_security_shield.png-wvc-sizes" alt="Secure data protection and privacy concept" className="object-cover w-full h-full" loading="lazy" />
            </AspectRatio>
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-secondary/40 to-transparent pointer-events-none" />
          </div>

          {/* Content Column */}
          <div className={`flex flex-col gap-8 transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-secondary leading-tight">
                You Control Your Digital Identity
              </h2>
              <p className="text-lg text-muted-foreground font-sans leading-relaxed">
                In an era of data vulnerability, we prioritize your privacy above all else. Our commitment to transparency means you always know exactly how your information is handled, protected, and kept under your absolute control.
              </p>
            </div>

            <div className="space-y-6">
              {specs.map((spec, i) => <div key={i} data-index={i} className="flex items-start gap-4">
                  <div className="mt-1 bg-secondary/10 p-2 rounded-md shrink-0">
                    <CircleCheck className="w-6 h-6 text-secondary" />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold font-default text-secondary mb-1">
                      {spec.title}
                    </h4>
                    <p className="text-muted-foreground font-sans">
                      {spec.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="w-full sm:w-auto text-base h-12 px-8 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-sm">
                <Link to="/ContactPage">
                  <CalendarCheck className="w-5 h-5 mr-2" />
                  View Privacy Policy
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-12 px-8 border-2 border-secondary text-secondary hover:bg-secondary/5 rounded-md">
                <Link to="/AboutUsPage">
                  <PhoneCall className="w-5 h-5 mr-2" />
                  Learn More
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}